<template>
    <nav id="sidebarMenu" class="col-md-3 col-lg-3 d-md-block sidebar collapse">
        <div class="position-sticky pt-3">
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center mt-4 mb-1">
            Sucursal
            </h6>
            <div>
                <multiselect
                v-model="selected_direccion"
                deselect-label="Can't remove this value"
                track-by="id" label="nombre"
                :preselect-first="true"
                :preselectFirst="true"
                :allow-empty="false"
                tagPlaceholder=""
                placeholder="Seleccione Sucursal"
                @input="change_form"
                :options="direcciones">
                  <template slot="singleLabel" slot-scope="{ option }">{{ option.nombre }}</template>
                </multiselect>
            </div>
            <!-- <div class="mb-3">
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center mt-4 mb-1">
                Fechas</h6>
                <div class="btn-group">
                    <button type="button" class="btn dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Últimos períodos
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item ng-scope" href="#"  @click="set_periodo(periodo)"
                        v-for="periodo in get_periodos()" v-bind:key="periodo.nombre">{{periodo.nombre}}</a>
                    </div>
                </div>
            </div> -->
            <div class="mb-3">
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center mt-4 mb-1">
                Fechas</h6>
                <div class="btn-group">
                    <button type="button" class="btn dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Últimos períodos
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item ng-scope" href="#"  @click="set_periodo(periodo)" v-for="periodo in get_periodos()" v-bind:key="periodo.nombre">{{periodo.nombre}}</a>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label>Desde</label>
                <input type="date" v-model="desde" placeholder="dd-mm-yyyy" @change="change_form()" class="form-control"/>
            </div>
            <div class="mb-4">
                <label>Hasta</label>
                <input type="date" v-model="hasta" :max="max" placeholder="dd-mm-yyyy" @change="change_form()" class="form-control"/>
            </div>
            <!-- <div class="mb-3" >

              <h6 class="sidebar-heading d-flex justify-content-between align-items-center mt-4 mb-1">
                Desde</h6>
                <div class="btn-group">
                    <button  v-if="!desde" type="button" class="btn dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Desde
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" v-if="!desde">
                        <a class="dropdown-item ng-scope" href="#"  @click="set_periodo_desde(periodo)"
                        v-for="periodo in get_periodos()" v-bind:key="periodo.nombre">{{periodo.nombre}}</a>
                    </div>
                    <a href="#" @click="desde=null" v-if="desde"> {{desde | moment("D MMM YYYY") }}</a>
                </div>
                <h6 class="sidebar-heading d-flex justify-content-between align-items-center mt-4 mb-1">
                Hasta</h6>
                <div class="btn-group">
                    <button v-if="!hasta"  type="button" class="btn dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Hasta
                    </button>
                    <div v-if="!hasta"  class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item ng-scope" href="#"  @click="set_periodo_hasta(periodo)"
                        v-for="periodo in get_periodos()" v-bind:key="periodo.nombre">{{periodo.nombre}}</a>
                    </div>
                    <a href="#" @click="hasta=null" v-if="hasta"> {{hasta | moment("D MMM YYYY") }}</a>
                </div>
                <a type="button" class="btn btn-primary" v-on:click="change_form()" v-if="desde && hasta" >
              <i class="fa fa-search"></i>  Buscar
            </a>
            </div> -->
            <hr>
            <ul class="nav flex-column">
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Cartola')" v-bind:class="[$route.name === 'Cartola' ? 'nav-link--active': 'nav-link']">Cartola <i class="fa fa-chevron-right"></i></a>
                </li>
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Sinader')" v-bind:class="[$route.name === 'Sinader' ? 'nav-link--active': 'nav-link']">Sinader <i class="fa fa-chevron-right"></i></a>
                </li>
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Documentos')" v-bind:class="[$route.name === 'Documentos' ? 'nav-link--active': 'nav-link']">Documentos <i class="fa fa-chevron-right"></i></a>
                </li>
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Ecoequivalencia')" v-bind:class="[$route.name === 'Ecoequivalencia' ? 'nav-link--active': 'nav-link']">Ecoequivalencia <i class="fa fa-chevron-right"></i></a>
                </li>
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Permisos')" v-bind:class="[$route.name === 'Permisos' ? 'nav-link--active': 'nav-link']">Permisos <i class="fa fa-chevron-right"></i></a>
                </li>
                <li class="nav-item">
                    <a href="#" class="" @click="get_link('Archivos')" v-bind:class="[$route.name === 'Archivos' ? 'nav-link--active': 'nav-link']">Archivos <i class="fa fa-chevron-right"></i></a>
                </li>
            </ul>
      </div>
      <!-- <div class="alert alert-warning" role="alert" >
                <b>¡IMPORTANTE!</b>
                 Recuerde que el proceso de revisión anual de la declaración 2020 en SINADER está en curso. Hay plazo hasta el <b>10 de septiembre</b> para realizarla.

              </div> -->
    </nav>

</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Menu',
  components: { Multiselect },
  props: {
    msg: String
  },
  data () {
    return {
      direcciones: [],
      selected_direccion: null,
      desde: null,
      hasta: null,
      user: null,
      max: this.$moment().endOf('month').format('YYYY-MM-DD') // this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      // activeClass: 'nav-link--active'
      // page: null
    }
  },

  watch: {
    // whenever question changes, this function will run
    // desde: { handler () { this.get_link(this.$route.name) } },
    // hasta: { handler () { this.get_link(this.$route.name) } }
  },
  // computed: {
  //   currentPage () {
  //     return this.$route.path
  //   }
  // },
  methods: {
    getUser () {
      var self = this
      axios.get('/users/info').then(function (res) {
        self.$store.commit('putUser', res.data)
        self.user = res.data
      })
    },

    search () {
      axios.get(`${process.env.VUE_APP_API_MAIN}/portal/direcciones/`)
        .then((res) => {
          this.$store.commit('putDirecciones', res.data)
          this.direcciones = res.data
          if (this.$route.params.id) {
            this.selected_direccion = res.data.find((sucursal) => sucursal.id === Number(this.$route.params.id))
          } else {
            this.selected_direccion = res.data[0]
            this.change_form()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    change_form (direccion) {
      // if (direccion){
      //   this.selected_direccion
      // }
      this.get_link(this.$route.name)
    },
    set_periodo (periodo) {
      this.desde = periodo.inicio
      this.hasta = periodo.termino
      this.change_form()
    },
    set_periodo_desde (periodo) {
      console.log(periodo)
      this.desde = periodo.inicio
      console.log(periodo)
    },
    set_periodo_hasta (periodo) {
      this.hasta = periodo.termino
    },
    get_periodos () {
      var self = this
      var diaFinal = this.$moment(this.hasta).date()
      var diaInicial = 1
      if (diaFinal < 28) {
        diaInicial = diaFinal + 1
      }

      var periodos = []
      // var deltas = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
      var deltas = [1, 2, 3, 4, 5, 6]
      deltas.forEach(function (delta) {
        var mes = self.$moment().subtract(delta, 'months')
        var periodo = {
          nombre: mes.format('MMMM YYYY').charAt(0).toUpperCase() + mes.format('MMMM YYYY').slice(1),
          inicio: mes.startOf('month').add(diaInicial - 1, 'days').format('YYYY-MM-DD'),
          termino: mes.startOf('month').add(diaFinal >= 28 ? mes.daysInMonth() - 1 : diaFinal - 1, 'days').format('YYYY-MM-DD')
        }
        periodos.push(periodo)
      })
      return periodos
    },

    get_link (modulo) {
      if (!this.selected_direccion) { return }
      var self = this
      self.$store.commit('putDireccion', this.direcciones.filter(function (d) { return d.id * 1 === self.selected_direccion * 1 })[0])
      modulo = modulo === '' ? 'Cartola' : modulo
      var route = {
        name: modulo,
        params: { id: this.selected_direccion.id },
        query: {
          desde: self.desde,
          hasta: self.hasta,
          t: (new Date()).getTime()
        }
      }
      this.$router.push(route)
    }
  },
  mounted () {
    // this.$moment.locale('fr')
    this.getUser()
    this.search()
    if (this.$route.query.desde) {
      this.desde = this.$moment(this.$route.query.desde).format('YYYY-MM-DD')
    } else {
      this.desde = this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
    }
    if (this.$route.query.hasta) {
      this.hasta = this.$moment(this.$route.query.hasta).format('YYYY-MM-DD')
    } else {
      this.hasta = this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    }
  }
}
</script>
